export const Favourite = () => (
  <svg
    width="47"
    height="47"
    viewBox="0 0 47 47"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <defs>
      <filter
        x="-25.8%"
        y="-15.3%"
        width="151.6%"
        height="152.8%"
        filterUnits="objectBoundingBox"
        id="q2zu9y3kva"
      >
        <feOffset dy="4" in="SourceAlpha" result="shadowOffsetOuter1" />
        <feGaussianBlur stdDeviation="2.5" in="shadowOffsetOuter1" result="shadowBlurOuter1" />
        <feColorMatrix
          values="0 0 0 0 0.407843137 0 0 0 0 0.607843137 0 0 0 0 0.878431373 0 0 0 0.24 0"
          in="shadowBlurOuter1"
        />
      </filter>
      <rect id="4mnrah9iob" x="1.127" y="1.6" width="36.8" height="36" rx="12.8" />
    </defs>
    <g fill="none" fillRule="evenodd">
      <g transform="translate(4)">
        <use fill="#000" filter="url(#q2zu9y3kva)" xlinkHref="#4mnrah9iob" />
        <use fill="#FFF" xlinkHref="#4mnrah9iob" />
      </g>
      <path
        d="M23.979 13.423c.421-.657.885-1.191 1.391-1.56.759-.576 1.686-.863 2.867-.863 1.306 0 2.487.493 3.33 1.314A4.232 4.232 0 0 1 33 15.476c0 2.094-1.096 4.147-2.782 6.241-1.602 1.971-3.71 3.983-5.86 5.954l-.38.329-.336-.329c-2.15-1.97-4.258-3.983-5.902-5.954C16.096 19.623 15 17.57 15 15.476c0-1.232.548-2.382 1.391-3.162A4.926 4.926 0 0 1 19.763 11c1.18 0 2.066.287 2.825.862.548.37.97.904 1.39 1.56z"
        fill="#0A77EC"
      />
    </g>
  </svg>
);
